import { useParams, NavLink, Outlet, Navigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';
import { siteGetSite } from '../../api';

export function SiteDetailPage() {
	const { siteId } = useParams<{ siteId: string }>();
	const id = parseInt(siteId ?? '', 10);
	const validId = !!siteId && Number.isFinite(id);

	const { data: site, isLoading } = useQuery({
		queryKey: ['sites', id],
		queryFn: () => siteGetSite({ id }),
		enabled: validId,
	});

	if (!validId) {
		return <Navigate to="/sites" replace />;
	}

	const tabClassName = ({ isActive }: { isActive: boolean }) =>
		`px-4 py-2 text-sm font-medium border-b-2 whitespace-nowrap ${
			isActive
				? 'border-smartfield text-smartfield'
				: 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
		}`;

	return (
		<div className="space-y-0 -my-6 -mx-4 sm:-mx-6">
			<div className="bg-white border-b border-gray-200 px-6 pt-6 pb-0">
				<div className="mb-4">
					<h1 className="text-2xl font-bold text-gray-900">
						{isLoading ? 'Loading…' : (site?.name ?? `Site ${id}`)}
					</h1>
					{site?.serialNumber && (
						<p className="text-sm text-gray-500 mt-1">{site.serialNumber}</p>
					)}
				</div>
				<nav className="flex gap-0 -mb-px">
					<NavLink to={`/sites/${id}/geometry`} className={tabClassName}>
						Geometry &amp; Devices
					</NavLink>
					<NavLink to={`/sites/${id}/notes`} className={tabClassName}>
						Notes
					</NavLink>
				</nav>
			</div>
			<div className="p-6">
				<Outlet />
			</div>
		</div>
	);
}
